export type Entry = { tr: string; en: string; de: string; fr: string; ar: string; es: string };

import { common } from "./i18n/common";
import { landing } from "./i18n/landing";
import { auth } from "./i18n/auth";
import { events } from "./i18n/events";
import { account } from "./i18n/account";

export const DICT: Record<string, Entry> = {
  ...common,
  ...landing,
  ...auth,
  ...events,
  ...account,
};
